import { useState } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { Info, TriangleAlert, X } from 'lucide-react';
import { usePublicConfig } from '@/routes/auth/OAuthButtons';
import { cn } from '@/lib/cn';

import { tr } from '@/i18n';
const KEY = 'lumo-announcement-dismissed';

/** Объявление администратора: плавающая пилюля внизу экрана, закрывается до следующего текста. */
export function AnnouncementBanner() {
  const cfg = usePublicConfig();
  const a = cfg.data?.announcement;
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(KEY);
    } catch {
      return null;
    }
  });
  const visible = !!a?.text && dismissed !== a.text;
  return (
    <AnimatePresence>
      {visible && a && (
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 12 }}
          role="status"
          className={cn(
            'glass fixed bottom-4 left-1/2 z-[900] flex max-w-[calc(100vw-32px)] -translate-x-1/2 items-center gap-2.5 !rounded-full py-2 pr-2 pl-4 text-[13px]',
            a.tone === 'warning' && 'ring-1 ring-[#F76B15]/30',
          )}
        >
          {a.tone === 'warning' ? <TriangleAlert className="size-4 shrink-0 text-[#F76B15]" /> : <Info className="size-4 shrink-0 text-accent-fg" />}
          <span className="min-w-0">{a.text}</span>
          <button
            type="button"
            aria-label={tr("Скрыть объявление")}
            onClick={() => {
              setDismissed(a.text);
              try {
                localStorage.setItem(KEY, a.text);
              } catch {
                /* ignore */
              }
            }}
            className="inline-flex size-7 shrink-0 items-center justify-center rounded-full text-fg-subtle hover:bg-hover hover:text-fg"
          >
            <X className="size-3.5" />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
